import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnnouncementService } from '../../core/services/announcement.service';
import { Notification } from '@app/core/api/models/notifications.model';

@Component({
    selector: 'app-announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.css'],
    standalone: false
})
export class AnnouncementComponent implements OnInit {
  announcements: Notification[] = [];
  userId: string;
  readIds: Set<string> = new Set();

  constructor(
    private announcementService: AnnouncementService,
    private dialogRef: MatDialogRef<AnnouncementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userId: string }
  ) {
    this.userId = data.userId;
  }

  ngOnInit(): void {
    this.announcements = this.announcementService.getAll();
    // Capture which items were already read BEFORE marking all as read
    const alreadyRead = this.announcementService.getReadIds(this.userId);
    this.readIds = new Set(alreadyRead);
    this.announcementService.markAllAsRead(this.userId);
  }

  isUnread(id: string): boolean {
    return !this.readIds.has(id);
  }

  close(): void {
    this.dialogRef.close();
  }
}
